import React, {useContext} from 'react';
import Metrika from './trackers/metrika';

const TRACKER_APIS = [new Metrika()];

const Context = React.createContext({
  async handleEvent() {
    // Event handler code goes here
  },
});

const AnalyticsProvider = ({children}) => {
  const handleEvent = async (key, value) => {
    await Promise.all(
      TRACKER_APIS.map(provider => provider.handleEvent(key, value)),
    );
  };

  return <Context.Provider value={{handleEvent}}>{children}</Context.Provider>;
};

const AnalyticsProviderWrapper = ({children}) => {
  return <AnalyticsProvider>{children}</AnalyticsProvider>;
};

export function useAnalytics() {
  const context = useContext(Context);

  return {
    handleEvent(...args) {
      return async () => {
        context.handleEvent(...args);
      };
    },
  };
}

export default {
  Context,
  Consumer: Context.Consumer,
  Provider: AnalyticsProviderWrapper,
};
